import * as React from 'react';

import Layout from "../Layout"
import LeafletMap from "../LeafletMap"

const MapPage = (props) => {

    return (
        <Layout>
            <LeafletMap/>
        </Layout>
    );
};

export default MapPage;